import React, { useEffect } from 'react';
import { useStore, useAuth } from '../../store/useStore';
import LoginForm from './LoginForm';

interface AuthGuardProps {
  children: React.ReactNode;
}

export const AuthGuard: React.FC<AuthGuardProps> = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const { checkAuth } = useStore();

  useEffect(() => {
    // Check authentication status on mount
    checkAuth();
  }, [checkAuth]);

  if (!isAuthenticated) {
    return <LoginForm onSuccess={() => {
      // Force re-check authentication after successful login
      checkAuth();
    }} />;
  }

  return <>{children}</>;
};

export default AuthGuard;